module.exports = __webpack_public_path__ + "d810f62137d64a0a58035c80489b7d54.svg";